var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { SystemParamService } from '~/services/management-service/system-param.service';
import ModifyParameter from '~/components/system-manage/param-manage/modify-parameter.vue';
var SystemParameterManage = /** @class */ (function (_super) {
    __extends(SystemParameterManage, _super);
    function SystemParameterManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queryModel = {
            paramName: '',
            paramCode: '',
            paramValue: '',
            paramStatus: '',
        };
        _this.sysParamDataSet = [];
        _this.dialog = {
            modifysysparamterDialog: false,
        };
        _this.modifyData = {};
        return _this;
    }
    SystemParameterManage.prototype.refreshData = function () {
        var _this = this;
        this.sysParamService
            .getSystemParams(this.queryModel, this.pageService)
            .subscribe(function (data) {
            _this.sysParamDataSet = data;
        });
    };
    SystemParameterManage.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 修改系统参数
     */
    SystemParameterManage.prototype.modifyParam = function (scope) {
        this.modifyData = scope.row;
        this.dialog.modifysysparamterDialog = true;
    };
    __decorate([
        Dependencies(SystemParamService)
    ], SystemParameterManage.prototype, "sysParamService", void 0);
    __decorate([
        Dependencies(PageService)
    ], SystemParameterManage.prototype, "pageService", void 0);
    SystemParameterManage = __decorate([
        Auth(14),
        Layout('workspace'),
        Component({
            components: {
                ModifyParameter: ModifyParameter,
            },
        })
    ], SystemParameterManage);
    return SystemParameterManage;
}(Vue));
export default SystemParameterManage;
